<template>
  <div>
    <h1 class="title mqu-subtitle">
      Capital Gain and Capital Loss
    </h1>
    <rv-has name="has-capital-gain" label="Do you receive a share of any capital gain?" v-model="data.hasCapitalGain"/>
    <transition name="fade" mode="out-in">
      <div v-if="data.hasCapitalGain">
        <capital-gain v-model="data.capitalGain" v-on:input="update"/>
      </div>
    </transition>
    <rv-has name="has-capital-loss" label="Do you pay a share of any capital loss?" v-model="data.hasCapitalLoss"/>
    <transition name="fade" mode="out-in">
      <div v-if="data.hasCapitalLoss">
        <capital-loss v-model="data.capitalLoss" v-on:input="update"/>
      </div>
    </transition>
  </div>
</template>

<script>
import CapitalGain from '../inputs/capital-gain-loss/CapitalGain'
import CapitalLoss from '../inputs/capital-gain-loss/CapitalLoss'
import RvHas from '../inputs/RvHas'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    RvHas,
    CapitalLoss,
    CapitalGain
  },
  data() {
    return {
      data: {
        hasCapitalGain: this.value.hasCapitalGain,
        hasCapitalLoss: this.value.hasCapitalLoss,
        capitalGain: this.value.capitalGain,
        capitalLoss: this.value.capitalLoss
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  },
  watch: {
    'data.hasCapitalGain': function() {
      this.update()
    },
    'data.hasCapitalLoss': function() {
      this.update()
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/CapitalGainLoss.vue